import { environmentConfig } from "@src/appV2/environment";

export function rosterWindowSettingsUrl(workplaceId: string): string {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/roster-window-settings`;
}

export const ROSTER_WINDOW_SETTINGS_URL_SUFFIX = "/roster-window-settings";
